import React from "react";
import Footer from "../components/Footer";
import Landing from "../components/Landing";
import Nav from "../components/Nav";

const LandingPage = () => {
  return (
    <main>
      {/* <Nav /> */}
      <Landing />
    </main>
  );
};

export default LandingPage;
